export var PrepositionEnum;
(function (PrepositionEnum) {
    PrepositionEnum["DE"] = "de";
    PrepositionEnum["A"] = "\u00E0";
})(PrepositionEnum || (PrepositionEnum = {}));
